import React, { useState } from 'react';
import useAppContext from '../../../../hooks/useAppContext';
import { AppContextType } from '../../../../context/AppContext';
import CompanyName from '../../../commonComponents/CompanyName';
import { CompanyNameType } from '../../../../static/types/commonTypes/companyNameType';
import { GoArrowRight } from 'react-icons/go';
import { SlArrowLeft, SlArrowRight } from 'react-icons/sl';
import { FaUpload } from 'react-icons/fa';
import IndividualPerson from '../../../commonComponents/IndividualPerson';
import { IndividualPersonType } from '../../../../static/types/commonTypes/individualType';
import DateOfBirthAndCityComponent from '../../../commonComponents/DateOfBirthAndCity';
import { DateOfBirthAndCityType } from '../../../../static/types/commonTypes/dateOfBirthAndCity';
import AffectedIndividualsList from '../../../commonComponents/AffectedIndividualsList';
import { initialAffectedIndividualsState } from '../../../../static/initialState/commonInitialState/initialAffectedIndividualsState';
import NewLastName from './NewLastName';
import { AffectedIndividualsType } from '../../../../static/types/commonTypes/affectedIndividualsType';
import { formatObjectText } from '../../../../utils/functions/formatObjectText';

interface AnnonceProps {
    txtAnnonce: string;
    updateActiveIndex: (index: number) => void;
    updateTxtAnnonce: (newTxt: string) => void;
    updateDenomination: (newTxt: string) => void;
    societyType: string | string[];
    societeSelected: string;
    updatesocieteSelected: (newTxt: string) => void;
}

const ChangementNomPatronique: React.FC<AnnonceProps> = ({
    txtAnnonce,
    updateTxtAnnonce,
    updateActiveIndex,
    updateDenomination,
    societyType,
    updatesocieteSelected
}) => {

    const {

        companyName, setCompanyName,
        companyNameValidity, setCompanyNameValidity,
        companyNameChecked, setCompanyNameChecked,

        individual,
        setIndividual,
        individualValidity,
        setIndividualValidity,
        individualChecked,
        setIndividualChecked,

        dateOfBirth,
        setDateOfBirth,
        dateOfBirthValidity,
        setDateOfBirthValidity,
        dateOfBirthChecked,
        setDateOfBirthChecked,
        
        affectedIndividuals,
        setAffectedIndividuals,
        affectedIndividualsValidity,
        setAffectedIndividualsValidity,
        affectedIndividualsChecked,
        setAffectedIndividualsChecked,
        typeAffectedIndividualsData,
        setTypeAffectedIndividualsData,

        newLastName,
        setNewLastName,
        newLastNameValidity,
        setNewLastNameValidity,
        newLastNameChecked,
        setNewLastNameChecked,
        typeNewLastNameData,
        setTypeNewLastNameData,

        fullName,

    } = useAppContext() as AppContextType

    const [activeTab, setActiveTab] = useState<string>('companyName');
    const [visitedTabs, setVisitedTabs] = useState(['companyName']);
    const [ submissive, setSubmissive ] = useState<boolean>( false );

    const handleSubmit = (e: React.FormEvent) => {

        e.preventDefault();

        if (validate()) {

            const childText = affectedIndividuals.map ((currentindividual: AffectedIndividualsType) => `${currentindividual.civility === 'Monsieur' ? 'M.' : 'Mme.'} ${currentindividual.lastName} ${currentindividual.firstName} , ${currentindividual.civility === 'Monsieur' ? 'né' : 'née'} le ${currentindividual.dateOfBirth} à ${currentindividual.city} (${currentindividual.postalCode.substring(0, 2)})`).join(" et ");

            const qualityPlural = `agissant tant en son nom personnel qu’au nom de ${affectedIndividuals.length >1 ? 'ses enfants mineurs' : 'son enfant mineur'} ${childText}`;

            const newNameText = typeNewLastNameData === 0 
            ? `, celui de ${newLastName}, afin de s'appeler à l'avenir :
${newLastName}`
            : (fullName.additionalName || fullName.fullName) 
            ? `${fullName.additionalName ? `, celui de ${fullName.additionalName}` : ''} ${fullName.fullName ? `, afin de s'appeler à l'avenir :
${fullName.fullName}` : ''}`
            : '.';


        const tempText =`${individual.civility === 'Monsieur' ? 'M.' : 'Mme.'} ${individual.lastName} ${individual.firstName}, né le ${dateOfBirth.dateOfBirth} à ${dateOfBirth.cities}, demeurant ${individual.address} ${individual.additionalAddress ? individual.additionalAddress : ''} ${individual.postalCode} ${individual.city}, ${typeAffectedIndividualsData !== 0 ? `${qualityPlural}, ` : ``}dépose une requête auprès du Garde des Sceaux à l'effet de substituer à son nom patronymique${newNameText}.`

            const formattedText = formatObjectText(tempText);
            updateTxtAnnonce(formattedText);
            updateDenomination (companyName.companyName);
        }
    };
 
    const validate = () => {
        if (!companyNameValidity) {
            setActiveTab('companyName')
        } else if (!individualValidity) {
            setActiveTab('civilStatus')
        } else if (!dateOfBirthValidity) {
            setActiveTab('birthDateAndCity')
        } else if (typeAffectedIndividualsData !== 0) {
            setAffectedIndividualsChecked(true)
            if (!affectedIndividualsValidity)
                setActiveTab('affectedIndividuals');
        } else if (typeNewLastNameData !== 1) {
            setNewLastNameChecked(true)
            if (!newLastNameValidity)
                setActiveTab('newLastName');
        }
            let tempAffectedIndividualsValidity = typeAffectedIndividualsData === 0 ? true : affectedIndividualsValidity
        return companyNameValidity && individualValidity && dateOfBirthValidity && newLastNameValidity && tempAffectedIndividualsValidity;
    };

    const handleNext = () => {
        if (activeTab === "companyName") {
            setCompanyNameChecked(true)
            if (companyNameValidity) {
                switchTab(getNextTab('companyName'));
            }
        } else if (activeTab === "civilStatus") {
            setIndividualChecked(true)
            if (individualValidity) {
                switchTab(getNextTab('civilStatus'));
            }
        } else if (activeTab === "birthDateAndCity") {
            setDateOfBirthChecked(true)
            if (dateOfBirthValidity) {
                switchTab(getNextTab('birthDateAndCity'))
            }
        } else if (activeTab === "affectedIndividuals") {
            if (typeAffectedIndividualsData === 0) { 
                switchTab(getNextTab('affectedIndividuals'));
            } else if (typeAffectedIndividualsData === 1 || typeAffectedIndividualsData === 2)
                setAffectedIndividualsChecked(true)
                if(affectedIndividualsValidity) {
                    switchTab(getNextTab('affectedIndividuals'));
                }
        } else if (activeTab === "newLastName") {
            if (typeNewLastNameData === 0) {
                setNewLastNameChecked(true)
                if (newLastNameValidity) {
                    setSubmissive (true)
                }
            } else if (typeNewLastNameData === 1) {
                setSubmissive (true)
            }
        }
    };

    const handlePrevious = () => {
        switchTab(getPreviousTab(activeTab));
        setSubmissive( false )
    };

    const getNextTab = (currentTab: string) => {
        if (currentTab === "companyName") return "civilStatus";
        else if (currentTab === "civilStatus") return "birthDateAndCity";
        else if (currentTab === "birthDateAndCity") return "affectedIndividuals";
        else if (currentTab === "affectedIndividuals") return "newLastName";
        else return currentTab;
    }
    

    const getPreviousTab = (currentTab: string) => {
        if (currentTab === "newLastName") return "affectedIndividuals";
        else if (currentTab === "affectedIndividuals") return "birthDateAndCity";
        else if (currentTab === "birthDateAndCity") return "civilStatus";
        else if (currentTab === "civilStatus") return "companyName";
        else return currentTab;
    }

    const goToSupportPresse = () => {
        updateActiveIndex(2);
    }

    const switchTab = (tab: string) => {
setActiveTab(tab);
    };

    const updateCompanyName = (data: Partial<CompanyNameType>) => setCompanyName ({...companyName, ...data});
    const updateIndividualPerson = (data: Partial<IndividualPersonType>) => setIndividual ({...individual, ...data});
    const updateDateOfBirth = (data: Partial<DateOfBirthAndCityType>) => setDateOfBirth ({...dateOfBirth, ...data});

    const tabs = [
        {key: 'companyName', label: 'Raison Sociale'},
        {key: 'civilStatus', label: 'Etat civil actuel'},
        {key: 'birthDateAndCity', label: 'Date de naissance et ville de naissance'},
        {key: 'affectedIndividuals', label: 'Personnes concernés par ce changement de nom'},
        {key: 'newLastName', label: 'Nouveau nom de famille'},

    ]

    return (
        <>
            <div>
                <p className='text-danger'>
                    Attention : L'annonce légale de changement de nom patronymique doit être publiée dans un JAL et au Journal Officiel. Nous pouvons également prendre en charge la parution de votre annonce légale au Journal Officiel sur simple demande par mail à annonces@legal2digital.fr.
                </p>
            </div>
                <div className="container my-3">
                <ul className="nav nav-underline">
                    {tabs
                    .filter((t) => t.key === activeTab) 
                    .map((t) => (
                        <li className="nav-item" key={t.key}>
                        <a
                            href={`#${t.key}`}
                            className={`nav-link active`} 
                        >
                            {t.label}
                        </a>
                        </li>
                    ))}
                    </ul>
                </div>
            <form onSubmit={handleSubmit}>
                {
                    activeTab === 'companyName' &&
                        <div>
                            <span className='mb-2'>
                                Indiquer la raison sociale de la société ou la dénomination du Cabinet de Notaire annonceur ou l'état civil de la personne concernée par l'annonce, en optionnel vous pouvez ajouter une référence client.
                            </span>
                            <div className="tab-content mt-2">
                                <CompanyName
                                    changeCompanyName={updateCompanyName}
                                    checked = {companyNameChecked}
                                    companyName= {companyName}
                                    onValidationChange={(isValid: boolean) => setCompanyNameValidity (isValid)}
                                    showClientReference= {true}
                                />
                            </div>
                        </div>
                    }

                {
                    activeTab === 'civilStatus' && 
                        <IndividualPerson
                            individual= {individual}
                            checked= {individualChecked}
                            changeIndividual= {updateIndividualPerson}
                            onValidationChange= {(isValid: boolean) => setIndividualValidity (isValid)}
                            draftFieldName = 'individual'
                        />
                }
                {
                    activeTab === 'birthDateAndCity' && 
                        <DateOfBirthAndCityComponent
                            dateOfBirth= {dateOfBirth}
                            checked= {dateOfBirthChecked}
                            onChange={updateDateOfBirth}
                            onValidationChange={(isValid: boolean) => setDateOfBirthValidity (isValid)}
                        />
                }

                {
                    activeTab === 'affectedIndividuals' &&
                        <div>
                            <div className='col-sm-10 d-flex align-items-center mt-1'>
                                <label htmlFor="affectedIndividuals" className="col-sm-auto col-form-label me-3">
                                    Personnes
                                </label>
                                <select
                                    className='form-select w-75'
                                    id='affectedIndividuals'
                                    onChange={(e) => {
                                        setAffectedIndividuals([initialAffectedIndividualsState])
                                        setTypeAffectedIndividualsData(Number(e.target.value))
                                    }}
                                    value={typeAffectedIndividualsData}
                                >
                                    <option value={0}>Moi uniquement</option>
                                    <option value={1}>Moi et mes enfants</option>
                                    <option value={2}>Mes enfants</option>
                                </select>
                            </div>

                            {
                                 typeAffectedIndividualsData !== 0 &&
                                    <div className='col-sm-12'>
                                        <AffectedIndividualsList
                                            individuals={affectedIndividuals}
                                            checked= {affectedIndividualsChecked}
                                            setIndividuals={setAffectedIndividuals}
                                            setIndividualsValidity={setAffectedIndividualsValidity}
                                            addButtonText='Saisir un enfant'
                                            removeButtonText='Supprimer le dernier enfant'
                                        />
                                    </div>
                            }
                        </div>
                        
                }

                {
                    activeTab === 'newLastName' && 
                        <div>
                            <NewLastName />
                            {
                                submissive &&
                                activeTab === 'newLastName' && 
                                <div className="mt-4">
                                    <h4>Texte de l'annonce:</h4>
                                    <textarea
                                        className="form-control"
                                        rows={5}
                                        value={ txtAnnonce }
                                        disabled
                                    />
                                </div>
                            }
                        </div>
                }

                <div className="button-container">
                    <div className="d-flex gap-2">
                        {
                            activeTab !== 'companyName' && (
                                <button color="#F4A261"
                                    className="btn-add"
                                    type="button"
                                    onClick={handlePrevious} >
                                    <SlArrowLeft className="icon" style={{ marginRight: '10px',fontSize: '20px' }} />
                                    Modifier mon annonce
                                </button>
                        )}

                        {
                            activeTab === 'newLastName' && (
                                <button type="submit"
                                    onClick={handleNext}>
                                    Mettre à jour mon annonce
                                    <FaUpload className="icon" style={{ marginLeft: '15px', fontSize: '20px' }} />
                                </button>
                        )}

                        {
                            activeTab !== 'newLastName' && (
                                <button color="#F4A261"
                                    className="btn-add"
                                    type="button"
                                    onClick={handleNext} >
                                    Suivant
                                    <SlArrowRight className="icon" style={{ marginLeft: '10px', fontSize: '20px' }} />
                                </button>
                        )}

                        {
                            submissive && activeTab === 'newLastName' && (
                                <button color="#F4A261"
                                    className="btn-add"
                                    type="button"
                                    onClick={goToSupportPresse} >
                                    Sélection du support
                                    <GoArrowRight className="icon" style={{ marginLeft: '10px', fontSize: '20px' }} />
                                </button>
                        )} 
                    </div>
                </div>
                
            </form>
        </>
    );
};

export default ChangementNomPatronique;